<template>
  <div class="notice">
    <div class="table-info">
      <div class="breadcrumb">
        <span>位置：</span>
        <el-breadcrumb separator="/">
          <el-breadcrumb-item>通知公告</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <h3>通知公告</h3>
    </div>
    <!-- 表格 -->
    <div class="table-content">
      <div class="tool-bar">
        <span>关键字：</span>
        <el-input v-model="keyword" size="small" placeholder="请输入" width="264" class="key-word"></el-input>
        <el-button type="primary" size="small" @click="search" v-if="isCompleted && isShowButton('查询')">查询</el-button>
        <el-button size="small" @click="reset" v-if="isCompleted && isShowButton('重置')">重置</el-button>
        <el-button size="small" type="primary" @click="handleAdd('新增')" v-if="isCompleted && isShowButton('新增公告')">新增公告</el-button>
      </div>
      <!-- 表格 -->
      <template>
        <el-table
          :data="tableData"
          v-if="hasTableData"
          v-loading="loading"
          style="width: 100%">
          <!-- <el-table-column type="expand">
            <template slot-scope="props">
              <el-form label-position="left" inline class="demo-table-expand">
                <el-form-item label="公告内容:">
                  <span>{{ props.row.content }}</span>
                </el-form-item>
              </el-form>
            </template>
          </el-table-column> -->
          <el-table-column
            prop="title"
            label="公告标题"
            width="260">
          </el-table-column>
          <el-table-column
            prop="readers"
            label="阅读对象">
            <template slot-scope="scope">
              <span v-if="scope.row.readers.length >= 5">
                <div style="height:60px;width:1020px;overflow:auto;">
                  {{scope.row.readers}}
                </div>
              </span>
              <!-- <span v-if="scope.row.readers.length < 14">
                <div style="height:30px;width:1020px;line-height:30px;">
                  {{scope.row.readers}}
                </div>
              </span> -->
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="content"
            label="公告内容"
            width="480">
          </el-table-column> -->
          <el-table-column
            prop="createdTime"
            label="发布时间"
            width="180">
          </el-table-column>
          <el-table-column
            label="操作"
            width="180">
            <template slot-scope="scope">
              <el-button v-if="userName == scope.row.operator.value" @click="editNotice(scope.row)" type="text" size="small">编辑</el-button>
              <el-button v-if="userName == scope.row.operator.value" type="text" size="small" @click="deleteNotice(scope.row)">删除</el-button>
              <el-button type="text" size="small" @click="view(scope.row)">查看</el-button>
              <!-- <el-popover
                placement="top"
                width="160"
                v-model="scope.row.isDel">
                <p>确定删除？</p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="scope.row.isDel = false">取消</el-button>
                  <el-button type="primary" size="mini" @click="scope.row.isDel = false, deleteNotice(scope.row)">确定</el-button>
                </div>
                <el-button slot="reference" type="text" @click="scope.row.idDel = true">删除</el-button>
              </el-popover> -->
            </template>
          </el-table-column>
        </el-table>
      </template>
      <!-- 分页 -->
      <el-pagination
        @size-change='changeSize'
        @current-change='changeCurrentPage'
        :current-page.sync='currentPage'
        :page-sizes='[10, 20, 50]'
        :page-size='pageSize'
        layout='total, sizes, prev, pager, next, jumper'
        :total="total">
      </el-pagination>
    </div>
    <!-- 新增公告模态框 -->
    <el-dialog :title="title" :visible.sync="dialogShow">
      <el-form :inline="true" :rules="formRules" :model="ruleForm" ref="ruleForm">
        <el-row v-if="title != '公告内容'">
          <el-col class="title" :span="11" :offset="2">
            <el-form-item label="公告标题:" prop="title">
              <el-input v-model="ruleForm.title" placeholder="请输入" size="mini"></el-input>
            </el-form-item>
          </el-col>
          <el-col class="title" :span="11">
            <el-form-item label="过期时间:" prop="expireDate">
              <el-date-picker
                v-model="ruleForm.expireDate"
                type="datetime"
                size="mini"
                :picker-options="pickerOptions0"
                placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="title != '公告内容'">
          <el-col :span="11" :offset="2">
            <el-form-item label="医院分组:" size="small" prop="userGroup">
              <template>
                <el-radio-group :max="1" v-model="userGroup" @change="changeCheckBox(userGroup)">
                  <el-radio-button v-for="(item, index) in userGroupList" :key="index" :label="item.groupName"></el-radio-button>
                </el-radio-group>
              </template>
            </el-form-item>
          </el-col>
          <el-col class="title" :span="11">
            <el-form-item label="阅读对象:" prop="readers">
              <el-select v-model="ruleForm.readers" multiple placeholder="请选择" size="mini">
                <el-option
                  v-for="item in ruleForm.readObjectList"
                  :key="item.id"
                  :label="item.hospitalName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="title" :span="22"  :offset="2" :disabled="true">
            <div class="editor">
              <el-form-item label="公告内容:" style="width:100%">
                <editor ref="editor" :value="ruleForm.content" @on-change="handleChange" />
              </el-form-item>
            </div>

          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogShow = false">取 消</el-button>
        <el-button v-if="title != '公告内容'" type="primary" @click="handleSubmit('ruleForm')">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import moment from 'moment'
import Editor from './editor'
import isShowButton from '@/mixins'
export default {
  mixins: [isShowButton],
  components: {
    Editor
  },
  data() {
    return {
      loading: true,
      isCompleted: false, //是否请求完成
      btnPremissionList: [],
      menuId: this.$route.query.menuId,

      noticeContent: '',
      userName: localStorage.getItem('userName'),
      content: '',
      // visible2: false,
      userGroupList: [],
      userGroup: [],
      totalCache: '',
      keyword: '',
      title: '',
      currentPage: 1,
      pageSize: 10,
      dialogShow: false,  //控制模态框显示/隐藏
      tableData: [{
        title: '公告标题',
        readObject: '阅读对象',
        content: '公告内容',
        date: '发布时间'
      }],
      hasTableData: false, // 是否已经获取到tableData数据
      ruleForm: {
        title: '',
        expireDate: '',
        content: '',
        readers: [],
        readObjectList: [{
          readObject: 1,
          label: '对象1'
        }]
      },
      readObjectList: [],
      formRules: {
        title: [
          { required: true, message: '请输入公告标题', trigger: 'blur' },
          { max: 30, message: '长度最多为30个字符', trigger: 'blur' }
        ],
        expireDate: [
          { required: true, message: '请输入过期时间', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入公告内容', trigger: 'blur' }
        ],
        readers: [
          { required: true, message: '请选择阅读对象', trigger: 'change' }
        ]
      },
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },

    }
  },
  created() {
    this.getBtnRole()
    this.getAllReadObj()
    this.getAllNotice(this.currentPage, this.pageSize)
    this.getAllGroup(1, 99999)
  },
  computed: {
    total() {
      return parseInt(this.totalCache)
    },
    editor() {
      return this.$refs.myQuillEditor.quill
    }
  },
  methods: {
    // 公告富文本框
    handleChange(html, text) {
      // console.log(html)
      this.ruleForm.content = html
      this.noticeContent = html
    },
    // 查看公告内容
    view(val) {
      // console.log('查看')
      this.title = '公告内容'
      this.dialogShow = true
      this.Axios.get('/api/Notice/GetNoticeInfo?noticeID=' + val.id).then(res => {
        // console.log(res.data)
        const data = res.data
        if (data.status === 100) {
          let readObj = []
          for (let item of data.data.readers) {
            readObj.push(item.key)
          }
          data.data.readers = readObj
          data.data.readObjectList = this.readObjectList
          this.ruleForm = data.data
          this.ruleForm.content = this.$refs.editor.setHtml(data.data.content)
        }
      })
    },
    // 获取所有医院分组
    getAllGroup(pageindex, pagesize) {
      let arr = []
      this.Axios.get('/api/GroupHospital/GetGroupHospitalList?pageindex=' + pageindex + '&pagesize=' + pagesize).then(res => {
        // console.log(res.data)
        const data = res.data
        if (data.status === 100) {
          this.userGroupList = data.data
        } else {
          this.$message({
            showClose: true,
            message: '请求失败,请重新刷新!',
            type: 'error'
          })
        }
      })
    },
    // 分组
    changeCheckBox(groupName) {
      let id
      for (let item of this.userGroupList) {
        if (item.groupName == groupName) {
          id = item.id
        }
      }
      if (id != undefined) {
        this.Axios.get('/api/GroupHospital/GetGroupHospitalInfoById?id=' + id).then(res => {
        // console.log(res.data)
          const data = res.data
          let arr = []
          if (data.status === 100) {
            for (let item of data.data) {
              arr.push(item.id)
            }
            this.ruleForm.readers = arr
          } else if (data.status == 201) {

          } else {
            this.$message({
              showClose: true,
              message: '获取数据失败,请重试!',
              type: 'error'
            });
          }
        })
      } else {
        this.ruleForm.readers = []
      }
    },
    // 查询
    search() {
      this.getAllNotice(1, 10, this.keyword)
    },
    // 查询所有阅读对象
    getAllReadObj() {
      this.Axios.get('/api/Hospital/GetAllHospitals').then(res => {
        const data = res.data
        if (data.status === 100) {
          this.ruleForm.readObjectList = data.data
          this.readObjectList = data.data
        } else {
          this.$message({
            showClose: true,
            message: '获取阅读对象失败!',
            type: 'error'
          })
        }
      })
    },
    // 重置
    reset() {
      this.keyword = ''
      this.getAllNotice(1, 10)
    },
    // 点击新增公告按钮
    handleAdd(word) {
      this.dialogShow = true
      this.title = '新增公告'
      this.ruleForm.readObject = []
      for (let item in this.ruleForm) {
        if (item == 'readObjectList') {
          continue
        }
        this.ruleForm[item] = ''
      }
      this.ruleForm.readers = []
    },
    // 新增 / 修改公告
    doNoticeEditSave() {
      let readObj = []
      for (let item of this.ruleForm.readers) {
        for (let readItem of this.ruleForm.readObjectList) {
          if (readItem.id == item) {
            readObj.push({
              key: readItem.id,
              value: readItem.hospitalName
            })
          }
        }
      }
      const formData = {
        title: this.ruleForm.title,
        content: this.ruleForm.content,
        expireDate: moment(this.ruleForm.expireDate).format('YYYY-MM-DD HH:mm:ss'),
        readers: JSON.parse(JSON.stringify(readObj))
      }
      if (this.title == '新增公告') {
          // this.doNoticeSave()
        this.Axios.post('/api/Notice/AddNotice', formData).then(res => {
          const data = res.data
          if (data.status === 100) {
            this.$message({
              showClose: true,
              message: '添加成功!',
              type: 'success'
            })
            this.dialogShow = false
            this.getAllNotice(this.currentPage, this.pageSize)
          } else {
            this.$message({
              showClose: true,
              message: '添加失败!',
              type: 'error'
            })
          }
        })
      } else {
        formData.id = this.ruleForm.id
        // this.ruleForm.content = this.noticeContent
        formData.content = this.noticeContent
        // console.log('编辑公告',formData)
        this.Axios.put('/api/Notice/UpdateNotice', formData).then(res => {
          // console.log(res.data)
          const data = res.data
          if (data.status === 100) {
            this.$message({
              showClose: true,
              message: '修改成功!',
              type: 'success'
            })
            this.dialogShow = false
            this.getAllNotice(this.currentPage, this.pageSize)
          } else {
            this.$message({
              showClose: true,
              message: '修改失败,请联系管理员!',
              type: 'success'
            })
          }
        })
      }
    },
    // 删除公告
    deleteNotice(val) {
      // console.log('删除', val)
      this.Axios.delete('/api/Notice/DeleteNotice?noticeID=' + val.id).then(res => {
        const data = res.data
        if (data.status === 100) {
          this.$message({
            showClose: true,
            message: '删除成功!',
            type: 'success'
          })
          this.getAllNotice(this.currentPage, this.pageSize)
        } else {
          this.$message({
            showClose: true,
            message: '删除失败!',
            type: 'error'
          })
        }
      })
    },
    // 点击编辑公告按钮
    editNotice(val) {
      this.dialogShow = true
      this.title = '编辑公告'
      this.Axios.get('/api/Notice/GetNoticeInfo?noticeID=' + val.id).then(res => {
        // console.log(res.data)
        const data = res.data
        if (data.status === 100) {
          this.noticeContent = data.data.content
          let readObj = []
          for (let item of data.data.readers) {
            readObj.push(item.key)
          }
          data.data.readers = readObj
          data.data.readObjectList = this.readObjectList
          this.ruleForm = data.data
          // this.ruleForm.content = this.ruleForm.content
          // console.log(this.ruleForm.content)
          // console.log(this.$refs.editor)
          this.ruleForm.content = this.$refs.editor.setHtml(this.ruleForm.content)

          // console.log(this.ruleForm)
        }
      })
    },
    // 提交表单  修改新增
    handleSubmit(formName) {
      // console.log(formName)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.doNoticeEditSave()
        } else {
          this.$message({
            showClose: true,
            message: '请把数据补充完整!',
            type: 'error'
          })
          // console.log(this.noticeContent)
          return false

        }
      })
    },
    // 获取所有公告
    getAllNotice(currentPage, pageSize, keyword) {
      const data = {
        start: currentPage,
        pagesize: pageSize,
        keyword: keyword
      }
      this.loading = true
      this.Axios.get('/api/Notice/GetNoticeList', {params: data}).then(res => {
        const data = res.data
        if (data.status === 100) {
          for (let item of data.data) {
            // item.isDel = false
            this.$set(item, 'isDel', false)
            let readObj = []
            for (let readItem of item.readers) {
              readObj.push(readItem.value)
            }
            item.readers = readObj.join(', ')
          }
          this.tableData = data.data
          // console.log(this.tableData)
          this.totalCache = data.total
          this.loading = false
          this.hasTableData = true
        } else {
          this.$message({
            showClose: true,
            message: '网络错误请联系管理员!',
            type: 'error'
          })
        }
      })
    },
    // 改变每页显示数
    changeSize(pageSize) {
      this.getAllNotice(this.currentPage, pageSize)
    },
    // 改变当前页
    changeCurrentPage(currentPage) {
      this.getAllNotice(currentPage, this.pageSize)
    }
  }
}
</script>

<style lang="less">
.notice {
  .ql-editor.ql-blank, .ql-editor {
    height: 250px;
  }
  .breadcrumb {
    overflow: hidden;
    span,
    .el-breadcrumb {
      float: left;
    }
    span {
      font-size: 14px;
      color: #666;
      line-height: 1;
    }
  }
  .table-content {
    .tool-bar {
      padding: 0 20px;
      span {
        font-size: 14px;
        // color: rgba(0, 0, 0, 0.85);
        font-weight: 400;
      }
      .key-word,
      .status {
        width: 264px;
        margin-right: 40px;
      }
    }
    .el-table {
      margin: 20px 0;
      .marginRight10 {
        margin-right: 10px;
      }
    }
    .el-pagination {
      /deep/ .number,
      /deep/ .btn-prev,
      /deep/ .btn-next {
        background-color: #fff;
        border: 1px solid #d9d9d9;
        width: 32px;
        height: 32px;
      }
    }
  }
  .editor {
    // /deep/ .el-form-item /deep/ .is-required {
    //   width: 100%;
    //   /deep/ .el-form-item__content {
    //     width: 90%
    //   }
    // }
    /deep/ .el-form-item__content {
      width: 77%
    }
  }
  /deep/ .el-dialog__header {
    border-bottom: 1px solid #d9d9d9;
  }
  /deep/ .el-dialog__footer {
    border-top: 1px solid #d9d9d9;
  }
  /deep/ .el-textarea__inner {
    width: 635px;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/RemoteMedical/notice.vue